import { render, staticRenderFns } from "./BankCardManagement.vue?vue&type=template&id=35b9efc9&"
import script from "./BankCardManagement.vue?vue&type=script&lang=js&"
export * from "./BankCardManagement.vue?vue&type=script&lang=js&"
import style0 from "./BankCardManagement.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports